import * as ng from 'angular';
import { RepeatDirective } from './repeat-directive.directive';

export const RepeatDirectiveModule: string =
    ng.module('repeat-directive', [
    ])
        .directive('repeatDirective', RepeatDirective)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/repeat-directive/repeat-directive.module.ts